export const createServerFieldMappings = (numberOfMembers: number): Record<'form1' | 'form2', Record<string, string>> =>
  [...Array(numberOfMembers || 0).keys()].reduce(
    (acc: Record<'form1' | 'form2', Record<string, string>>, cur) => {
      if (cur === 0) {
        acc.form1[`CustomerProductsRequests[${cur}].Products`] = 'product';
        acc.form2[`CustomerProductsRequests[${cur}].Profile.FirstName`] = 'mainMember.firstName';
        acc.form2[`CustomerProductsRequests[${cur}].Profile.LastName`] = 'mainMember.lastName';
        acc.form2[`CustomerProductsRequests[${cur}].Profile.DateOfBirth`] = 'mainMember.birthDate';
        acc.form2[`CustomerProductsRequests[${cur}].Profile.Email`] = 'mainMember.eMail';
        acc.form2[`CustomerProductsRequests[${cur}].Profile.PhoneNumber`] = 'mainMember.phoneNumber';
        acc.form2[`CustomerProductsRequests[${cur}].Profile.Address`] = 'mainMember.address';
        acc.form2[`CustomerProductsRequests[${cur}].Profile.PostalCode`] = 'mainMember.zip';
        acc.form2[`CustomerProductsRequests[${cur}].Profile.City`] = 'mainMember.city';
      } else {
        acc.form2[`CustomerProductsRequests[${cur}].Profile.Email`] = `otherMembers.${cur - 1}.eMail`;
        acc.form2[`CustomerProductsRequests[${cur}].Profile.FirstName`] = `otherMembers.${cur - 1}.firstName`;
        acc.form2[`CustomerProductsRequests[${cur}].Profile.LastName`] = `otherMembers.${cur - 1}.lastName`;
        acc.form2[`CustomerProductsRequests[${cur}].Profile.DateOfBirth`] = `otherMembers.${cur - 1}.birthDate`;
        acc.form2[`CustomerProductsRequests[${cur}].Profile.Email`] = `otherMembers.${cur - 1}.eMail`;
        acc.form2[`CustomerProductsRequests[${cur}].Profile.PhoneNumber`] = `otherMembers.${cur - 1}.phoneNumber`;
        acc.form2[`CustomerProductsRequests[${cur}].Profile.Address`] = `otherMembers.${cur - 1}.address`;
        acc.form2[`CustomerProductsRequests[${cur}].Profile.PostalCode`] = `otherMembers.${cur - 1}.zip`;
        acc.form2[`CustomerProductsRequests[${cur}].Profile.City`] = `otherMembers.${cur - 1}.city`;
      }
      return acc;
    },
    { form1: {}, form2: {} },
  );
